/** @file startKeyOf: the key a drag starts from (the frame's own key, else the interpolated value). */
import { sampleNodeKey } from '@zilo/pose3d-commands/pose/sampleNodeKey';
import type { Clip, NodeKey } from '@zilo/pose3d-format/types/clip';

/** The node's key at `frame` when the clip keys it there, else commands' `sampleNodeKey` (`{}` before any key). */
export function startKeyOf(clip: Pick<Clip, 'keys'>, node: string, frame: number): NodeKey {
  const own = clip.keys.find((k) => k.frame === frame)?.nodes[node];
  return own === undefined ? sampleNodeKey(clip, node, frame) : structuredClone(own);
}
